import React from 'react';

export type TabContextType = {
  id?: number | string;
  currentIndex?: number;
  setCurrentIndex?: (currentIndex: number) => void;
  size?: number | string;
  focusIndex?: number | string;
  orientation?: 'horizontal' | 'vertical';
  setFocusIndex?: (focusIndex: number) => void;
  showOutline?: boolean;
  setShowOutline?: (showOutline: boolean) => void;
  isManual?: boolean;
  variant: 'chips' | 'underline';
  updateDisabledMap: (map: Record<number, boolean>) => void;
  isDisabled: (index: number) => boolean;
  moveToIndex: (index: number, relative?: boolean) => void;
  setTabsCount: (index: number) => void;
};

const TabContext = React.createContext<TabContextType | undefined>(undefined);

export default TabContext;
